import React from "react";
import Grid from "@material-ui/core/Grid";
import ButtonGroup from "@material-ui/core/ButtonGroup";
import SubmitButton from "components/Button";
import imgLoading from "asset/img/loading.gif";
import { useTranslation } from "react-i18next";
import styles from "../styles";

interface ValidatePageActionsProps {
  loading: boolean;
  onReportIssue: () => void;
}

const ValidatePageActions = React.memo((props: ValidatePageActionsProps) => {
  const { loading, onReportIssue } = props;
  const translate = useTranslation().t;
  const classes = styles();

  return (
    <Grid style={{ paddingTop: "20px" }} container spacing={1} direction="row">
      <Grid item xs={12} sm={12} md={6} lg={6}>
        <ButtonGroup fullWidth>
          <SubmitButton disabled={loading} type="submit" variant="contained">
            {loading ? (
              <img alt="loading" src={imgLoading} width="30px" />
            ) : (
              translate("MARK_AS_VALIDATED")
            )}
          </SubmitButton>
        </ButtonGroup>
      </Grid>
      <Grid item xs={12} sm={12} md={6} lg={6}>
        <ButtonGroup fullWidth>
          <SubmitButton
            disabled={loading}
            type="button"
            variant="contained"
            className={classes.reportButton}
            onClick={onReportIssue}
          >
            {translate("REPORT_ISSUE")}
          </SubmitButton>
        </ButtonGroup>
      </Grid>
    </Grid>
  );
});

export default ValidatePageActions;
